// useStickyStore.js
import { create } from 'zustand';

interface StickyStoreState {
    isStickyVisible: boolean;
    setIsStickyVisible: (visible: boolean) => void;
    isTopPwaBannerVisible: boolean;
    setIsTopPwaBannerVisible: (visible: boolean) => void;
}
const useStickyStore = create<StickyStoreState>((set) => ({
    isStickyVisible: false,
    setIsStickyVisible: (visible: boolean) => set({ isStickyVisible: visible }),
    isTopPwaBannerVisible: false,
    setIsTopPwaBannerVisible: (visible: boolean) => set({ isTopPwaBannerVisible: visible }),
}));

export default useStickyStore;
